// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Terms .page[data-v-ddd10d60]{padding:2rem;background-color:#fff}", ""]);
// Exports
module.exports = exports;
